export {onPageTransitionStart};

import {reportLoadingStart} from '../components/LoadingContext.jsx';

// Client-only by default; runs on every client-side navigation so the LoadingBar
// shows for all route changes, not just pages that manually call setLoading().
function onPageTransitionStart() {
    reportLoadingStart();
}
